import { render, staticRenderFns } from "./UserPasswordReset.vue?vue&type=template&id=78ce849c&scoped=true&"
import script from "./UserPasswordReset.vue?vue&type=script&lang=js&"
export * from "./UserPasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ce849c",
  null
  
)

export default component.exports